import React from "react";
import "../allcourses/courses.css"; // Ensure you have the correct styles

const Departments = () => {
  const departments = [
    { name: "Civil Engineering", duration: "3 Years", students: 60 },
    { name: "Computer Science",  duration: "3 Years", students: 120 },
    { name: "Electrical and Electronics", duration: "3 Years", students: 60 },
    { name: "Electronics and Communication", duration: "3 Years", students: 60},
    { name: "Mechanical Engineering", duration: "3 Years", students: 120 },
  ];

  return (
    <section className="departments">
      <div className="container">
        <h2 className="departments-title">DEPARTMENTS & COURSES</h2>
        <div className="yellow-line1"></div>
        <table className="departments-table">
          <thead>
            <tr>
              <th>Department</th>
              
              <th>Course Duration</th>
              <th>No. of Students</th>
            </tr>
          </thead>
          <tbody>
            {departments.map((dept, index) => (
              <tr key={index}>
                <td>{dept.name}</td>
               
                <td>{dept.duration}</td>
                <td>{dept.students}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default Departments;
